import CircularProgress from '@material-ui/core/CircularProgress'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ListItemText from '@material-ui/core/ListItemText'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import BlockIcon from '@material-ui/icons/Block'
import EventAvailableIcon from '@material-ui/icons/EventAvailable'
import EventNoteIcon from '@material-ui/icons/EventNote'
import MoneyIcon from '@material-ui/icons/LocalAtm'
import SyncIcon from '@material-ui/icons/Sync'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    bookingInventoryAvailability,
    bookingInventoryOrder,
    bookingLoadBasedOnReservationSummary,
    bookingOtelmsInventory,
    bookingPushYearPrices,
    bookingPushYearRestrictions
} from '../../../../../api/bookingApi/bookingSync'
import { selectCurrentOrganization } from '../../../../../selectors/bookingSelectors/bookingCurrentOrganization'

const styles = theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        width: '95%'
    },
    progress: {
        margin: theme.spacing.unit * 2
    }
})

class SyncTab extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        bookingPushYearPrices: PropTypes.func,
        bookingPushYearRestrictions: PropTypes.func,
        bookingInventoryAvailability: PropTypes.func,
        bookingInventoryOrder: PropTypes.func,
        bookingOtelmsInventory: PropTypes.func,
        bookingLoadBasedOnReservationSummary: PropTypes.func,
        pendingPushYearPrices: PropTypes.bool,
        pendingPushYearRestrictions: PropTypes.bool,
        pendingInventoryAvailability: PropTypes.bool,
        pendingInventoryOrder: PropTypes.bool,
        pendingOtelmsInventory: PropTypes.bool,
        pendingLoadBasedOnReservationSummary: PropTypes.bool,
        organizationId: PropTypes.number.isRequired
    }

    handlePushYearPrices = () => this.props.bookingPushYearPrices({ organizationIds: [this.props.organizationId] })
    handlePushYearRestrictions = () =>
        this.props.bookingPushYearRestrictions({ organizationIds: [this.props.organizationId] })
    handleInventoryAvailability = () =>
        this.props.bookingInventoryAvailability({ organizationId: this.props.organizationId })
    handleInventoryOrder = () => this.props.bookingInventoryOrder({ organizationId: this.props.organizationId })
    handleOtelmsInventory = () => this.props.bookingOtelmsInventory({ organizationId: this.props.organizationId })
    handleLoadBasedOnReservationSummary = () =>
        this.props.bookingLoadBasedOnReservationSummary({ organizationId: this.props.organizationId })

    render() {
        const {
            classes,
            pendingPushYearPrices,
            pendingPushYearRestrictions,
            pendingInventoryAvailability,
            pendingInventoryOrder,
            pendingOtelmsInventory,
            pendingLoadBasedOnReservationSummary
        } = this.props

        return (
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <List>
                        <ListItem button onClick={this.handlePushYearPrices} disabled={pendingPushYearPrices}>
                            <ListItemIcon>
                                <MoneyIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Отправить цены"
                                secondary="Это действие отправляет цены в Booking.com на 1 год вперёд"
                            />
                            <ListItemSecondaryAction>
                                {pendingPushYearPrices && <CircularProgress className={classes.progress} />}
                            </ListItemSecondaryAction>
                        </ListItem>

                        <ListItem
                            button
                            onClick={this.handlePushYearRestrictions}
                            disabled={pendingPushYearRestrictions}
                        >
                            <ListItemIcon>
                                <BlockIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Отправить ограничения"
                                secondary="Это действие отправляет ограничения в Booking.com на 1 год вперёд"
                            />
                            <ListItemSecondaryAction>
                                {pendingPushYearRestrictions && <CircularProgress className={classes.progress} />}
                            </ListItemSecondaryAction>
                        </ListItem>

                        <ListItem
                            button
                            onClick={this.handleInventoryAvailability}
                            disabled={pendingInventoryAvailability}
                        >
                            <ListItemIcon>
                                <EventAvailableIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Inventory доступности"
                                secondary="Это действие сравнивает доступность в Booking.com и EasyMS. В случае несоответствия обновленная доступность отсылается в Booking.com"
                            />
                            <ListItemSecondaryAction>
                                {pendingInventoryAvailability && <CircularProgress className={classes.progress} />}
                            </ListItemSecondaryAction>
                        </ListItem>
                        <ListItem button onClick={this.handleInventoryOrder} disabled={pendingInventoryOrder}>
                            <ListItemIcon>
                                <EventNoteIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Inventory заказов"
                                secondary="Это действие проверяет все ли бронирования из Booking.com, у которых дата выезда в будущем, есть в EasyMS. Если нет, то эти бронирования будут добавлены в EasyMS"
                            />
                            <ListItemSecondaryAction>
                                {pendingInventoryOrder && <CircularProgress className={classes.progress} />}
                            </ListItemSecondaryAction>
                        </ListItem>
                        <ListItem button onClick={this.handleOtelmsInventory} disabled={pendingOtelmsInventory}>
                            <ListItemIcon>
                                <EventNoteIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="OtelMS Inventory"
                                secondary="Это действие заменяет заказы импортированные из OtelMS заказами из Booking.com, если найдены совпадения"
                            />
                            <ListItemSecondaryAction>
                                {pendingOtelmsInventory && <CircularProgress className={classes.progress} />}
                            </ListItemSecondaryAction>
                        </ListItem>
                        <ListItem
                            button
                            onClick={this.handleLoadBasedOnReservationSummary}
                            disabled={pendingLoadBasedOnReservationSummary}
                        >
                            <ListItemIcon>
                                <SyncIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Создать заказы на основании Summary"
                                secondary="Необходимо вызывать при подключении нового объекта. Это действие создает бронирования, основанные на методе Summary (неполная информация), потому что обычным способом невозможно вытащить заказы, которые были сделаны до подключения объекта к EasyMS"
                            />
                            <ListItemSecondaryAction>
                                {pendingLoadBasedOnReservationSummary && (
                                    <CircularProgress className={classes.progress} />
                                )}
                            </ListItemSecondaryAction>
                        </ListItem>
                    </List>
                </Paper>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    organizationId: selectCurrentOrganization(state),
    pendingPushYearPrices: state.bookingSync.pendingPushYearPrices,
    pendingPushYearRestrictions: state.bookingSync.pendingPushYearRestrictions,
    pendingInventoryAvailability: state.bookingSync.pendingInventoryAvailability,
    pendingInventoryOrder: state.bookingSync.pendingInventoryOrder,
    pendingOtelmsInventory: state.bookingSync.pendingOtelmsInventory,
    pendingLoadBasedOnReservationSummary: state.bookingSync.pendingLoadBasedOnReservationSummary
})

export default connect(
    mapStateToProps,
    {
        bookingPushYearPrices,
        bookingPushYearRestrictions,
        bookingInventoryAvailability,
        bookingInventoryOrder,
        bookingOtelmsInventory,
        bookingLoadBasedOnReservationSummary
    }
)(withStyles(styles)(SyncTab))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/BookingTab/MappingTabs/SyncTab/SyncTab.js